<template>
    <div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-green-90">
        <div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 text-grey-700 text-3xl sm:text-4xl">
			<a @click="goBack" @keypress.enter="goBack" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>
			
			Premium
		</div>
		<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-1 pb-5 text-grey-900 text-xl overflow-x-hidden overflow-y-auto">
			<p class="leading-tight text-red-1000 font-body" style="font-size: 1.6rem;">Get access to more features with premium!</p>
			
			<h4 class="block text-4xl mt-4 leading-tight text-green-900">Only</h4>
			<h3 class="inline-block text-8xl -mt-4 leading-tight text-red-600">£6</h3>
			<h4 class="inline-block text-4xl -mt-6 leading-tight text-red-400">/month</h4>
			
			<div class="block mb-8">
				<a v-if="user.subscribed" tabindex="0" href="https://app.payhere.co/customers" target="_blank" class="px-4 py-2 rounded-lg cursor-pointer text-white text-xl bg-grey-700 hover:bg-grey-800 focus:bg-grey-800">Manage subscription</a>
				<a v-else @click="openPayhere" @keypress.enter="openPayhere" tabindex="0" class="px-4 py-2 rounded-lg cursor-pointer text-white text-xl bg-grey-700 hover:bg-grey-800 focus:bg-grey-800">Get started</a>
				
				<p v-if="new_subscription" class="mt-8 -mb-2 text-grey-700 text-xl font-body">Reload the app to enable your premium features</p>
				<p v-if="error" class="mt-8 -mb-2 text-red-800 text-xl font-body">{{ error }}</p>
			</div>
			
			<div v-if="!user.free_trial_activated || user.premium_left.includes(' premium trip left') || user.premium_left.includes(' premium trips left')" class="my-4 mb-1 pt-5 pb-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-red-600 text-xl font-body">
				<h3 class="text-3xl text-red-70">Free trial</h3>
				<div v-if="!user.free_trial_activated">
					<p class="block text-white leading-tight font-body" style="font-size: 1.35rem;">
						Try out our premium features on your first trip by subscribing to our newsletter!*
					</p>
					<div>
						<a @click="subscribe" @keypress.enter="subscribe" tabindex="0" class="inline-block mt-2 mb-2 px-4 py-2 rounded-lg cursor-pointer text-red-800 text-xl bg-white hover:bg-red-80 focus:bg-red-80">Subscribe</a>
					</div>
				</div>
				<p v-else class="text-white leading-tight font-body" style="font-size: 1.35rem;">
					As a thank you for subscribing to our newsletter, we're giving you access to premium features on your first trip!*
				</p>
			</div>
			
			<h4 class="text-3xl mt-4 leading-tight text-green-900">More locations!</h4>
			<p class="leading-tight font-body" style="font-size: 1.4rem;">Unlock a larger number of locations to visit</p>
			
			<h4 class="text-3xl mt-4 leading-tight text-green-900">More themes!</h4>
			<p class="leading-tight font-body" style="font-size: 1.4rem;">Choose what type of places you want to see</p>
			
			<h4 class="text-3xl mt-4 leading-tight text-green-900">No advertising!</h4>
			<p class="leading-tight font-body" style="font-size: 1.4rem;">Hide all the adverts and sponsored locations</p>
			
			<h4 class="text-3xl mt-4 leading-tight text-green-900">Change trip length!</h4>
			<p class="leading-tight font-body" style="font-size: 1.4rem;">Change the number of checkpoints that you have to visit</p>
			
			<h4 class="text-3xl mt-4 leading-tight text-green-900 opacity-75">Start anywhere!</h4>
			<p class="leading-tight font-body opacity-75" style="font-size: 1.4rem;">Remove the restriction that forces you to start at a specific place</p>
			<h5 class="block md:inline-block text-2xl leading-tight text-red-500 font-body">Coming soon</h5>
			
			<div class="block h-px w-full bg-grey-800 mt-4"></div>
			
			<p v-if="!user.free_trial_activated" class="mt-6 leading-tight text-grey-800 text-lg font-body">
				*Most premium features will be unlocked automatically on your first trip
				after subscribing to the newsletter. Only available once per email address.
				This cannot be delayed until a future trip, disabled, or exchanged for a
				cash equivalent, and will not be restored if you cancel the trip. The
				premium trip must still begin at the default location for your city and you
				will still see advertising, like a free user would. The free trip will be used
				as soon as you press 'START', and will not be reimbursed if you cancel the trip
				before completion, or if it is marked as invalid by a moderator.
			</p>
			<p v-else-if="user.premium_left.includes(' premium trip left') || user.premium_left.includes(' premium trips left')" class="mt-6 leading-tight text-grey-800 text-lg font-body">
				*Most premium features will be unlocked automatically on your first trip
				as you have subscribed to the newsletter. Only available once per email address.
				This cannot be delayed until a future trip, disabled, or exchanged for a
				cash equivalent, and will not be restored if you cancel the trip. The
				premium trip must still begin at the default location for your city and you
				will still see advertising, like a free user would. The free trip will be used
				as soon as you press 'START', and will not be reimbursed if you cancel the trip
				before completion, or if it is marked as invalid by a moderator.
			</p>
			<p v-else class="mt-6 leading-tight text-grey-800 text-lg font-body">
				You have already used your free trial trip, which is only valid once per
				email address.
			</p>
		</div>
    </div>
</template>

<script>
import Storages from 'js-storage';
import axios from 'axios';

export default {
    name: 'Premium',
    path: '/premium',
	data() {
		return {
			error: '',
			storage: null,
			new_subscription: false,
			user: {
				id: 0,
				username: '',
				email: '',
				premium: false
			}
		}
	},
    created() {
        this.storage = Storages.localStorage;
		this.getCurrentUser();
    },
    methods: {
		goBack() {
			if (window.history.length == 1) {
				this.$router.replace("/settings");
				return;
			}
			
			this.$router.go(-1);
		},
		getCurrentUser() {
			this.key = this.storage.get('session_key');
			if (this.storage.isSet('authed_user')) {
				this.user = this.storage.get('authed_user');
			} else {
				this.$router.replace("/");
			}
		},
		openPayhere() {
			var that = this;
			PayHere.launch({
				embedURL: "https://app.payhere.co/lost-in-the-city/premium-3b4029b8-30fc-48e7-9221-76976ceb02ad",
				customerEmail: this.user.email,
				disableCustomer: "no",
				customFields: {
					account_username: this.user.username
				},
				onSuccess: function() {
					that.user.subscribed = true;
					that.new_subscription = true;
				},
				onClose: function() {
					if (that.new_subscription == true) {
						window.location.href = "/";
					}
				}
			})
		},
		subscribe() {
			var that = this;
			this.error = "";
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/newsletter/subscribe?email=' + this.user.email)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.error = "";
					that.user.free_trial_activated = true;
					that.user.premium = data.response.premium;
					that.user.premium_left = data.response.premium_left;
					that.storage.set('authed_user', that.user);
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An error has occured";
				}
			});
		}
    }
}
</script>